module.exports = __webpack_public_path__ + "img/flow.9094be7b.svg";